import { initializeApp } from 'firebase/app';

import {
  getRemoteConfig,
  fetchAndActivate,
  getValue,
} from 'firebase/remote-config';

const firebaseConfig = {
  apiKey: 'AIzaSyBQhGWH8jbfXy9cvuQZbGA604bJhHoAeFc',
  authDomain: 'agrosmart-mobile.firebaseapp.com',
  projectId: 'agrosmart-mobile',
  appId: '1:377789609723:web:e6c43b85ff6d30ca60225e',
};

const app = initializeApp(firebaseConfig);

export const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000; // 1 hour

export interface PdfTemplateConfig {
  pdfColumnCount: number;
  logoUrl: string;
}

const DEFAULT_PDF_CONFIG: PdfTemplateConfig = {
  pdfColumnCount: 2,
  logoUrl: '',
};

export async function getPdfTemplateConfig(
  templateCode: string,
): Promise<PdfTemplateConfig> {
  await fetchAndActivate(remoteConfig);

  const raw = getValue(remoteConfig, 'fn_template_config').asString();

  if (!raw) return DEFAULT_PDF_CONFIG;

  const config = JSON.parse(raw) as Record<string, PdfTemplateConfig>;

  const normalizedTemplateCode = templateCode.toLowerCase();

  const matchingKey = Object.keys(config)
    .filter((key) => normalizedTemplateCode.startsWith(key.toLowerCase()))
    .sort((a, b) => b.length - a.length)[0];

  return matchingKey ? config[matchingKey] : DEFAULT_PDF_CONFIG;
}
